import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { sstyled as _sstyled } from 'intergalactic/utils/lib/core/index';
import { assignProps as _assignProps2 } from 'intergalactic/core';
import { assignProps as _assignProps } from 'intergalactic/core';
import React from 'react';
import { findDOMNode } from 'react-dom';
import createComponent, { Component, sstyled, Root } from 'intergalactic/core';
import { Box } from 'intergalactic/flex-box';
import { getNodeByRef } from 'intergalactic/utils/lib/ref';
import contextEnhance from 'intergalactic/utils/lib/enhances/contextEnhance';
/*__reshadow-styles__:"./style/scroll-bar.shadow.css"*/
var style = ( /*__reshadow_css_start__*/_sstyled.insert( /*__inner_css_start__*/".___SScrollBar_fx5hn_gg_{position:absolute;display:flex}.___SScrollBar_fx5hn_gg_._orientation_vertical_fx5hn_gg_{top:var(--intergalactic-spacing-1x, 4px);right:0;width:8px;height:calc(100% - var(--offsetSum_fx5hn) - var(--intergalactic-spacing-2x, 8px));justify-content:center}.___SScrollBar_fx5hn_gg_._orientation_horizontal_fx5hn_gg_{bottom:0;height:12px;align-items:center;width:calc(100% - var(--offsetSum_fx5hn) - var(--intergalactic-spacing-2x, 8px))}.___SSlider_fx5hn_gg_{cursor:pointer;width:6px;height:6px;border-radius:4px;background-color:var(--intergalactic-scroll-bar-background, rgba(25, 27, 35, 0.3))}" /*__inner_css_end__*/, "fx5hn_gg_") /*__reshadow_css_end__*/, {
  "__SScrollBar": "___SScrollBar_fx5hn_gg_",
  "_orientation_vertical": "_orientation_vertical_fx5hn_gg_",
  "--offsetSum": "--offsetSum_fx5hn",
  "_orientation_horizontal": "_orientation_horizontal_fx5hn_gg_",
  "__SSlider": "___SSlider_fx5hn_gg_"
});
export var hideScrollBarsFromScreenReadersContext = /*#__PURE__*/React.createContext(false);
export var DEFAULT_SLIDER_SIZE = 50;

// updating DOM directly to avoid react dom rerendering and reconciliation
var setAriaValues = function setAriaValues($container, $horizontalBar, $verticalBar) {
  if (!$container || !($horizontalBar || $verticalBar)) return;
  var scrollWidth = $container.scrollWidth,
    clientWidth = $container.clientWidth,
    scrollHeight = $container.scrollHeight,
    clientHeight = $container.clientHeight,
    scrollLeft = $container.scrollLeft,
    scrollTop = $container.scrollTop;
  var maxScrollRight = scrollWidth - clientWidth;
  var maxScrollBottom = scrollHeight - clientHeight;
  if ($horizontalBar) {
    $horizontalBar.setAttribute('aria-valuenow', Math.floor(scrollLeft));
    $horizontalBar.setAttribute('aria-valuemax', maxScrollRight);
  }
  if ($verticalBar) {
    $verticalBar.setAttribute('aria-valuenow', Math.floor(scrollTop));
    $verticalBar.setAttribute('aria-valuemax', maxScrollBottom);
  }
};
var ScrollBarRoot = /*#__PURE__*/function (_Component) {
  _inherits(ScrollBarRoot, _Component);
  var _super = _createSuper(ScrollBarRoot);
  function ScrollBarRoot() {
    var _this;
    _classCallCheck(this, ScrollBarRoot);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "$bar", null);
    _defineProperty(_assertThisInitialized(_this), "$slider", null);
    _defineProperty(_assertThisInitialized(_this), "sliderStyle", {
      width: DEFAULT_SLIDER_SIZE,
      height: DEFAULT_SLIDER_SIZE
    });
    _defineProperty(_assertThisInitialized(_this), "kefScroll", {
      x: 0,
      y: 0
    });
    _defineProperty(_assertThisInitialized(_this), "kefBar", {
      x: 0,
      y: 0
    });
    _defineProperty(_assertThisInitialized(_this), "_scroll", {
      left: 0,
      top: 0
    });
    _defineProperty(_assertThisInitialized(_this), "_mouse", {
      pageX: 0,
      pageY: 0
    });
    _defineProperty(_assertThisInitialized(_this), "state", {
      visibleScroll: false
    });
    _defineProperty(_assertThisInitialized(_this), "refBar", function (node) {
      var domNode = findDOMNode(node);
      _this.$bar = domNode;
      var orientation = _this.getOrientation();
      var _this$asProps = _this.asProps,
        horizontalBarRef = _this$asProps.horizontalBarRef,
        verticalBarRef = _this$asProps.verticalBarRef;
      if (orientation === 'horizontal' && horizontalBarRef) horizontalBarRef.current = domNode;
      if (orientation === 'vertical' && verticalBarRef) verticalBarRef.current = domNode;
      setAriaValues(_this.$container, horizontalBarRef === null || horizontalBarRef === void 0 ? void 0 : horizontalBarRef.current, verticalBarRef === null || verticalBarRef === void 0 ? void 0 : verticalBarRef.current);
    });
    _defineProperty(_assertThisInitialized(_this), "refSlider", function (node) {
      _this.$slider = findDOMNode(node);
    });
    _defineProperty(_assertThisInitialized(_this), "calculate", function () {
      if (!_this.$container) return;
      var visibleScroll = _this.calculateVisibleScroll();
      _this.setState({
        visibleScroll: visibleScroll
      }, function () {
        if (!_this.$container || !_this.$bar || !_this.$slider) return;
        var orientation = _this.getOrientation();
        _this.sliderStyle = _this.calculateSliderStyle();
        _this.kefBar = _this.calculateKefBar();
        _this.kefScroll = _this.calculateKefScroll();
        if (orientation === 'horizontal') {
          _this.$slider.style.width = "".concat(_this.sliderStyle.width, "px");
        } else if (orientation === 'vertical') {
          _this.$slider.style.height = "".concat(_this.sliderStyle.height, "px");
        }
        _this.handleScroll();
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleScroll", function () {
      if (!_this.$container || !_this.$slider) return;
      var _this$$container = _this.$container,
        scrollTop = _this$$container.scrollTop,
        scrollLeft = _this$$container.scrollLeft;
      var orientation = _this.getOrientation();
      if (orientation === 'horizontal') {
        _this.$slider.style.transform = "translateX(".concat(scrollLeft * _this.kefScroll.x, "px)");
      } else if (orientation === 'vertical') {
        _this.$slider.style.transform = "translateY(".concat(scrollTop * _this.kefScroll.y, "px)");
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleSelectStartDocument", function (e) {
      return e.preventDefault();
    });
    _defineProperty(_assertThisInitialized(_this), "handleMouseMoveDocument", function (e) {
      var pageX = e.pageX,
        pageY = e.pageY;
      var _this$_scroll = _this._scroll,
        left = _this$_scroll.left,
        top = _this$_scroll.top;
      var _this$kefScroll = _this.kefScroll,
        x = _this$kefScroll.x,
        y = _this$kefScroll.y;
      var orientation = _this.getOrientation();
      if (orientation === 'horizontal') {
        _this.$container.scrollLeft = _this.calculateScrollByDiff(pageX, _this._mouse.pageX, left, x);
      } else if (orientation === 'vertical') {
        _this.$container.scrollTop = _this.calculateScrollByDiff(pageY, _this._mouse.pageY, top, y);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleMouseUpDocument", function () {
      document.removeEventListener('mousemove', _this.handleMouseMoveDocument, true);
      document.removeEventListener('mouseup', _this.handleMouseUpDocument, true);
      document.removeEventListener('selectstart', _this.handleSelectStartDocument, true);
    });
    _defineProperty(_assertThisInitialized(_this), "handleMouseDownSlider", function (e) {
      // canceling the emergence of a real scroll
      e.stopPropagation();
      // save mouse coordinates (relative to the page)
      _this._mouse = {
        pageX: e.pageX,
        pageY: e.pageY
      };
      // save the scroll of the container
      // TODO: what happens if the content increases while we scroll?
      var _this$$container2 = _this.$container,
        scrollLeft = _this$$container2.scrollLeft,
        scrollTop = _this$$container2.scrollTop;
      _this._scroll = {
        left: scrollLeft,
        top: scrollTop
      };
      document.addEventListener('mousemove', _this.handleMouseMoveDocument, true);
      document.addEventListener('mouseup', _this.handleMouseUpDocument, true);
      document.addEventListener('selectstart', _this.handleSelectStartDocument, true);
    });
    _defineProperty(_assertThisInitialized(_this), "handleMouseDownBar", function (e) {
      // cancellation of the ascent as in a real scroll
      e.stopPropagation();
      var pageX = e.pageX,
        pageY = e.pageY;
      var _window = window,
        pageXOffset = _window.pageXOffset,
        pageYOffset = _window.pageYOffset;
      var _this$$bar$getBoundin = _this.$bar.getBoundingClientRect(),
        left = _this$$bar$getBoundin.left,
        top = _this$$bar$getBoundin.top;
      var orientation = _this.getOrientation();
      if (orientation === 'horizontal') {
        _this.$container.scrollLeft = _this.calculateScrollByClick(left, pageXOffset, pageX, _this.kefBar.x, _this.kefScroll.x);
      } else if (orientation === 'vertical') {
        _this.$container.scrollTop = _this.calculateScrollByClick(top, pageYOffset, pageY, _this.kefBar.y, _this.kefScroll.y);
      }
    });
    return _this;
  }
  _createClass(ScrollBarRoot, [{
    key: "$container",
    get: function get() {
      return getNodeByRef(this.asProps.container);
    }
  }, {
    key: "calculateVisibleScroll",
    value: function calculateVisibleScroll() {
      var orientation = this.getOrientation();
      var _this$calculateOrient = this.calculateOrientation(),
        _this$calculateOrient2 = _slicedToArray(_this$calculateOrient, 2),
        horizontal = _this$calculateOrient2[0],
        vertical = _this$calculateOrient2[1];
      if (horizontal && orientation === 'horizontal') {
        return true;
      } else if (vertical && orientation === 'vertical') {
        return true;
      }
      return false;
    }
  }, {
    key: "calculateKefScroll",
    value: function calculateKefScroll() {
      var _this$$container3 = this.$container,
        clientWidth = _this$$container3.clientWidth,
        clientHeight = _this$$container3.clientHeight,
        scrollWidth = _this$$container3.scrollWidth,
        scrollHeight = _this$$container3.scrollHeight;
      var _this$$bar = this.$bar,
        clientWidthBar = _this$$bar.clientWidth,
        clientHeightBar = _this$$bar.clientHeight;
      var _this$sliderStyle = this.sliderStyle,
        width = _this$sliderStyle.width,
        height = _this$sliderStyle.height;
      return {
        x: (clientWidthBar - width) / (scrollWidth - clientWidth),
        y: (clientHeightBar - height) / (scrollHeight - clientHeight)
      };
    }
  }, {
    key: "calculateKefBar",
    value: function calculateKefBar() {
      var _this$$bar2 = this.$bar,
        clientWidth = _this$$bar2.clientWidth,
        clientHeight = _this$$bar2.clientHeight;
      var _this$sliderStyle2 = this.sliderStyle,
        width = _this$sliderStyle2.width,
        height = _this$sliderStyle2.height;
      return {
        x: (clientWidth - width) / clientWidth,
        y: (clientHeight - height) / clientHeight
      };
    }
  }, {
    key: "calculateSliderStyle",
    value: function calculateSliderStyle() {
      var _this$$bar3 = this.$bar,
        clientWidth = _this$$bar3.clientWidth,
        clientHeight = _this$$bar3.clientHeight;
      var _this$$container4 = this.$container,
        scrollWidth = _this$$container4.scrollWidth,
        scrollHeight = _this$$container4.scrollHeight;
      var calculateDimensions = function calculateDimensions(visibleSize, totalSize) {
        var ratio = Math.min(visibleSize / totalSize, 1); // percentage of visible area
        return Math.round(visibleSize * ratio);
      };
      return {
        width: Math.max(calculateDimensions(clientWidth, scrollWidth), DEFAULT_SLIDER_SIZE),
        height: Math.max(calculateDimensions(clientHeight, scrollHeight), DEFAULT_SLIDER_SIZE)
      };
    }
  }, {
    key: "calculateScrollByClick",
    value: function calculateScrollByClick(position, windowOffset, mouseOffset, kefBar, kefScroll) {
      // bar coordinates relative to the page
      var barPage = position + windowOffset;

      // click coordinates - bar coordinates * proportion
      var scroll = (mouseOffset - barPage) * kefBar;
      return scroll / kefScroll;
    }
  }, {
    key: "calculateScrollByDiff",
    value: function calculateScrollByDiff(mouseOffset, oldMouseOffset, oldScroll, kefScroll) {
      // mouse offset (new coordinates - old coordinates)
      var offsetMouse = mouseOffset - oldMouseOffset;

      // old scroll position * scroll ratio + offset
      var scroll = oldScroll * kefScroll + offsetMouse;
      return scroll / kefScroll;
    }
  }, {
    key: "calculateOrientation",
    value: function calculateOrientation() {
      if (!this.$container) return [false, false];
      var _this$$container5 = this.$container,
        scrollWidth = _this$$container5.scrollWidth,
        scrollHeight = _this$$container5.scrollHeight,
        clientWidth = _this$$container5.clientWidth,
        clientHeight = _this$$container5.clientHeight;
      return [scrollWidth > clientWidth, scrollHeight > clientHeight];
    }
  }, {
    key: "getOrientation",
    value: function getOrientation() {
      if (this.asProps.orientation !== undefined) return this.asProps.orientation;
      var _this$calculateOrient3 = this.calculateOrientation(),
        _this$calculateOrient4 = _slicedToArray(_this$calculateOrient3, 2),
        horizontal = _this$calculateOrient4[0],
        vertical = _this$calculateOrient4[1];
      if (vertical) return 'vertical';
      if (horizontal) return 'horizontal';
    }
  }, {
    key: "subscribe",
    value: function subscribe($node) {
      if (!$node) return;
      $node.addEventListener('scroll', this.handleScroll);
      $node.addEventListener('calculate', this.calculate);
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe($node) {
      if (!$node) return;
      $node.removeEventListener('scroll', this.handleScroll);
      $node.removeEventListener('calculate', this.calculate);
    }
  }, {
    key: "getSliderProps",
    value: function getSliderProps() {
      return {
        ref: this.refSlider,
        onMouseDown: this.handleMouseDownSlider
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.subscribe(this.$container);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unsubscribe(this.$container);
    }
  }, {
    key: "render",
    value: function render() {
      var _ref = this.asProps,
        _ref3;
      var SScrollBar = Box;
      var _this$asProps2 = this.asProps,
        styles = _this$asProps2.styles,
        uid = _this$asProps2.uid,
        position = _this$asProps2.position,
        container = _this$asProps2.container,
        orientation = _this$asProps2.orientation,
        hideFromScreenReaders = _this$asProps2.hideFromScreenReaders;
      var visibleScroll = this.state.visibleScroll;
      var _this$asProps3 = this.asProps,
        leftOffset = _this$asProps3.leftOffset,
        rightOffset = _this$asProps3.rightOffset,
        topOffset = _this$asProps3.topOffset,
        bottomOffset = _this$asProps3.bottomOffset;
      if (!visibleScroll) {
        return null;
      }
      var offsetSum = 0;
      if (orientation === 'horizontal') {
        if (leftOffset) offsetSum += leftOffset;
        if (rightOffset) offsetSum += rightOffset;
        if (position === 'sticky' && container.current) {
          var _container$current$ge = container.current.getBoundingClientRect(),
            left = _container$current$ge.left,
            right = _container$current$ge.right;
          if (leftOffset) {
            leftOffset += left;
          }
          if (rightOffset) {
            rightOffset += right;
          }
        }
      }
      if (orientation === 'vertical') {
        if (topOffset) offsetSum += topOffset;
        if (bottomOffset) offsetSum += bottomOffset;
        if (position === 'sticky' && container.current) {
          var _container$current$ge2 = container.current.getBoundingClientRect(),
            top = _container$current$ge2.top,
            bottom = _container$current$ge2.bottom;
          if (topOffset) {
            topOffset += top;
          }
          if (bottomOffset) {
            bottomOffset += bottom;
          }
        }
      }
      return _ref3 = sstyled(styles), /*#__PURE__*/React.createElement(SScrollBar, _ref3.cn("SScrollBar", _objectSpread({}, _assignProps({
        "left": orientation === 'horizontal' && leftOffset ? "".concat(leftOffset, "px") : undefined,
        "right": orientation === 'horizontal' && rightOffset ? "".concat(rightOffset, "px") : undefined,
        "top": orientation === 'vertical' && topOffset ? "".concat(topOffset, "px") : undefined,
        "bottom": orientation === 'vertical' && bottomOffset ? "".concat(bottomOffset, "px") : undefined,
        "offsetSum": "".concat(offsetSum, "px"),
        "role": hideFromScreenReaders ? undefined : 'scrollbar',
        "aria-hidden": hideFromScreenReaders ? 'true' : undefined,
        "ref": this.refBar,
        "aria-valuemin": hideFromScreenReaders ? undefined : 0,
        "aria-controls": hideFromScreenReaders ? undefined : "igc-".concat(uid, "-scroll-container"),
        "aria-orientation": hideFromScreenReaders ? undefined : this.getOrientation(),
        "onMouseDown": this.handleMouseDownBar,
        "orientation": this.getOrientation()
      }, _ref))));
    }
  }]);
  return ScrollBarRoot;
}(Component);
_defineProperty(ScrollBarRoot, "displayName", 'Bar');
_defineProperty(ScrollBarRoot, "style", style);
_defineProperty(ScrollBarRoot, "enhance", [contextEnhance(hideScrollBarsFromScreenReadersContext, 'hideFromScreenReaders')]);
_defineProperty(ScrollBarRoot, "defaultProps", function () {
  return {
    container: /*#__PURE__*/React.createRef(),
    children: /*#__PURE__*/React.createElement(ScrollBar.Slider, null)
  };
});
function Slider(props) {
  var _ref2 = arguments[0],
    _ref4;
  var styles = props.styles;
  var SSlider = Box;
  return _ref4 = sstyled(styles), /*#__PURE__*/React.createElement(SSlider, _ref4.cn("SSlider", _objectSpread({}, _assignProps2({
    "onDragStart": function onDragStart() {
      return false;
    }
  }, _ref2))));
}
var ScrollBar = createComponent(ScrollBarRoot, {
  Slider: Slider
});
export { setAriaValues as setAreaValue };
export default ScrollBar;
//# sourceMappingURL=ScrollBar.js.map